export interface AttemptGuard {
  filterUnattempted: (ids: string[]) => string[];
  markAttempted: (ids: string[]) => void;
  release: (ids: string[]) => void;
  retain: (ids: string[]) => void;
}

/**
 * Tracks ids that a client-driven action (e.g. send notification, auto-bump)
 * has already been fired for, so the same id isn't re-fired every poll cycle
 * while the backend/list source is still catching up.
 */
export function createAttemptGuard(): AttemptGuard {
  const attempted = new Set<string>();

  return {
    filterUnattempted: (ids: string[]) => ids.filter(id => !attempted.has(id)),
    markAttempted: (ids: string[]) => {
      ids.forEach(id => attempted.add(id));
    },
    release: (ids: string[]) => {
      ids.forEach(id => attempted.delete(id));
    },
    retain: (ids: string[]) => {
      const keep = new Set(ids);
      attempted.forEach(id => {
        if (!keep.has(id)) attempted.delete(id);
      });
    },
  };
}
